// INDEX
export const ROOT = '';
export const INDEX = '/';
export const SPLASH = '/splash';
export const POLICY = '/policy';
export const DELETE_ACCOUNT = '/delete-account';
export const DOWNLOAD = '/download';


export const OFFER = '/docs/offer';
export const NOT_FOUND = '/404';

export const LOGIN = '/login';
export const CODE = '/code';
export const PROFILE = '/profile';
export const APPLICATION = '/application';
export const AVATAR = '/avatar';
export const ACTIVATE = '/activate';
export const MULTI_FORM = '/form';
export const STORY = '/story';
export const WRITE = '/write';
export const VIEWER_FILE = '/viewer/file';
export const VIEWER_TEXT = '/viewer/text';
export const WIDGET = '/widget';